import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonList, Button, ButtonVariant, PopoverHeaderTheme, IconName, IconSize, Popover, PopoverPosition, } from '@as/cotopaxi';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
export const SortControlPopover = ({ anchorEl, onClose, orderItems, currentOrderItem, onOrderChange, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const buttonListButtons = orderItems.map((item) => ({
        key: item.key,
        active: item.key === currentOrderItem.key,
        onClick: () => onOrderChange(item.key),
        text: t(item.value),
    }));
    return (_jsx(Popover, { noPadding: true, anchorEl: anchorEl, onClose: onClose, showTitleOnDesktop: false, headerTheme: PopoverHeaderTheme.SECONDARY, title: t('product.sort'), position: PopoverPosition.BOTTOM, leftElement: _jsx(Button, { variant: ButtonVariant.TRANSPARENT, onClick: onClose, icon: {
                name: IconName.CLOSE,
                size: IconSize.MAJOR,
            } }), children: _jsx(ButtonList, { buttons: buttonListButtons }) }));
};
